/* eslint-disable no-unreachable -- temporarily hide Haifa Cafe ad */
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Chip from '@mui/material/Chip';
import StarIcon from '@mui/icons-material/Star';

const FEATURED_BUSINESS = {
    restaurantId: '986ef69e44591c47',
    name: 'Haifa Cafe',
    tagline: 'Where Tradition Meets Community — Authentic Brews & Bites',
    imageUrl: 'https://haifacafe.ca/assets/images/hero.webp',
};

const FeaturedBusiness = ({ onClick }) => {
    // Temporarily hide Haifa Cafe ad
    return null;

    const handleClick = () => {
        onClick?.(FEATURED_BUSINESS.restaurantId);
    };

    return (
        <Box sx={{ px: 2, pt: 3, pb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                <StarIcon sx={{ color: '#FFB800', fontSize: 20, mr: 0.5 }} />
                <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ color: '#00C2FF' }}
                >
                    Featured Business
                </Typography>
                <Chip
                    label="Sponsored"
                    size="small"
                    sx={{
                        ml: 'auto',
                        fontSize: '0.65rem',
                        height: 20,
                        bgcolor: 'rgba(0,0,0,0.06)',
                        color: 'text.secondary',
                    }}
                />
            </Box>
            <Card
                elevation={4}
                sx={{
                    borderRadius: 3,
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                <CardActionArea onClick={handleClick}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={FEATURED_BUSINESS.imageUrl}
                        alt={FEATURED_BUSINESS.name}
                        sx={{ objectFit: 'cover' }}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%)',
                            px: 2.5,
                            pb: 2,
                            pt: 6,
                        }}
                    >
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{ color: '#fff', lineHeight: 1.2 }}
                        >
                            {FEATURED_BUSINESS.name}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ color: 'rgba(255,255,255,0.85)', mt: 0.5 }}
                        >
                            {FEATURED_BUSINESS.tagline}
                        </Typography>
                    </Box>
                </CardActionArea>
            </Card>
        </Box>
    );
};

export default FeaturedBusiness;
